import { render, staticRenderFns } from "./TransparentModal.vue?vue&type=template&id=9ec1482c&"
import script from "./TransparentModal.vue?vue&type=script&lang=ts&"
export * from "./TransparentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports